/* eslint-disable react-hooks/rules-of-hooks */

/**
 * @param requiredRoles 
 * @param userRoles 
 * @returns 
 */
export const userHasAllRoles = (requiredRoles: string | string[], userRoles: string[]) => {
  if (!userRoles || !requiredRoles) return false;
  
  const rolesToCheck = Array.isArray(requiredRoles) ? requiredRoles : [requiredRoles];
  
  return rolesToCheck.every(role => userRoles.includes(role));
};

/**
 * @param requiredRoles 
 * @param userRoles 
 * @returns 
 */
export const userHasAnyRole = (requiredRoles: string | string[], userRoles: string[]) => {
  if (!userRoles || !requiredRoles) return false;
  
  const rolesToCheck = Array.isArray(requiredRoles) ? requiredRoles : [requiredRoles];
  
  return rolesToCheck.some(role => userRoles.includes(role));
};